<script setup lang="ts">
import type { ICommodity, ICrypto, IRealEstate, IStock } from '~/@types/assets'
import AssetsAdapter from '@adapters/AssetsAdapter'
import { ref } from 'vue'
import AssetView from '~/components/assets/AssetView.vue'

const symbol = ref<string | null>(null)
const isViewOpen = ref(false)
const isLoading = ref(false)
const asset = ref<IStock | IRealEstate | ICrypto | ICommodity | null>(null)

async function search(): Promise<void> {
  if (!symbol.value) {
    return
  }

  isLoading.value = true
  isViewOpen.value = true
  asset.value = await AssetsAdapter.stockSearch(symbol.value)
  isLoading.value = false
}

function viewClosed() {
  isLoading.value = false
  asset.value = null
  symbol.value = null
  isViewOpen.value = false
}
</script>

<template>
  <header>
    <div class="mb-4 mt-8">
      <SubtitleComponent title="Asset search" />
    </div>

    <section class="flex justify-between">
      <div class="flex-1 pr-4">
        <InputComponent v-model="symbol" :autocorrect="false" uppercase label="Symbol" />
      </div>
      <ButtonComponent label="Search" class="m-0" @click="search" />
    </section>

    <AssetView :is-open="isViewOpen" :is-loading="isLoading" :asset="asset" @closed="viewClosed" />
  </header>
</template>
